import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from '../../services/index';
import { DeleteRequest } from '../../models/delete-request.model';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-delete-request-list',
  styleUrls: ['../defis/defi-list.component.scss'],
  templateUrl: './delete-request-list.component.html',
})
export class DeleteRequestListComponent implements OnInit {
  // font awesome
  public faEdit = faEdit;

  // loading indicator
  loading = false;

  @ViewChild('submittedItemTmpl', { static: true })
  submittedItemTmpl: TemplateRef<any>;
  @ViewChild('editItemTmpl', { static: true }) editItemTmpl: TemplateRef<any>;

  // column definition
  columns;

  data: Array<DeleteRequest>;

  constructor(private api: ApiService) {}

  ngOnInit() {
    this.columns = [
      { prop: 'requestId', name: 'Id', width: 10 },
      {
        prop: 'submitted',
        name: 'Submitted',
        cellTemplate: this.submittedItemTmpl,
        width: 70,
      },
      { prop: 'defi.place.typeName', name: 'Category', width: 80 },
      { prop: 'defi.name', name: 'Name', width: 300 },
      { prop: 'deleteReason', name: 'Reason', width: 300 },
      { name: 'Actions', cellTemplate: this.editItemTmpl, width: 20 },
    ];

    // indicate loading
    this.loading = true;

    // load data
    this.loadData();
  }

  private loadData() {
    // load data (take, skip)
    this.api.getDefiDeleteRequests().subscribe((response) => {
      // store the data
      this.data = new Array<DeleteRequest>();
      for (const entry of response) {
        this.data.push(new DeleteRequest().deserialize(entry));
      }

      // loading finished
      this.loading = false;
    });
  }
}
